import log from 'salvo-lite/log'
import axios from 'axios'

class ContactForm {
    constructor (theme, elem) {
        this._theme = theme
        this._elem = elem
        this._successMessage = elem.querySelector('.success-message')
        this._errorMessage = elem.querySelector('.error-message')

        log.debug(this.constructor.name, 'Constructed', this)
    }

    onInit () {
        this.initSubmitHandler()
    }

    initSubmitHandler () {
        this._elem.addEventListener('submit', event => {
            event.preventDefault()

            const data = new FormData(event.target)

            axios.post('/contact', data)
                .then(res => {
                    if (res.status === 200) {
                        this._successMessage.classList.add('active')
                    }
                })
                .catch(err => console.log(err))
        })
    }
}

export default ContactForm



// WEBPACK FOOTER //
// ./src/resources/scripts/components/ContactForm.js